import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import http from 'axios'

import { Paper } from '@mui/material'

import { withStyles } from '@mui/styles'
import { style } from 'styles'
import Products from './components/Products'
import { saveAccess } from 'core/lib'

function ProductsListFlat({ classes }) {
	const dispatch = useDispatch()
	const { products } = useSelector(state => state.products)
	/*
	 * Per riportare l'utente alla posizione precedente quando ritorna alla lista imposto un'altezza del contenitore molto alta,
	 * altrimenti quando il browser tenta di effettuare lo scroll i dati non sono acnora caricati e quella posizione non esiste nella pagina.
	 * Dopo il load dei prodotti imposto l'altezza su 'auto' così il contenitore si adatta al contenuto
	 */
	const [fakeHeight, setFakeHeight] = useState(50000)

	useEffect(() => {
		const loadProducts = async() => {
			const products = await http.get(`${window.__endpoint}/api/products`)
			dispatch({ type: 'loadProducts@products', products: products })

			// Imposto l'altezza giusta del container
			setFakeHeight('auto')

			// Salvo l'accesso
			saveAccess('products-list')
		}

		dispatch({ type: 'loadProducts@products', products: null })
		loadProducts()
	}, [])

	return (<div className={classes.page} style={{ height: fakeHeight }}>
		<div style={{ width: '90vw', justifyContent: 'center', marginRight: '1vw' }}>

			<Paper elevation={3} className="box" style={{ width: '100%' }}>
				<h3 className={classes.pageTitle}>Shop</h3>
				<Products
					products={products}
				/>
			</Paper>
		</div>
	</div>)
}

export default withStyles(style)(ProductsListFlat)
